export default __webpack_public_path__ + "static/media/2800_CCBJI_Logo.9e79d93e.bmp";